import posthog from "posthog-js";

export function initPostHogClient() {

  const postHogKey = import.meta.env.VITE_POSTHOG_KEY
  const postHogHost = import.meta.env.VITE_POSTHOG_HOST

  if (postHogKey) {
    posthog.init(postHogKey, {
      api_host: postHogHost,
      person_profiles: 'identified_only',
    })
  }

  return posthog
}
